import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {IProcessing} from "../../../../utils/interfaces/Catalogue/IProcessing";
import {useApp} from "../../../../utils/global-contexts/AppContext";
import useApi from "../../../../utils/custom-hooks/api-hooks/useApi";


const useApiCreateProcessing = (): UseMutationResult<IProcessing, AxiosError, {
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCategory, selectedEstimate} = useApp();

    const {postEncoded} = useApi()

    async function doMutation(data: any): Promise<IProcessing> {
        try {
            const response = await postEncoded(`/catalogue/processings`, data);
            return response.data.data as IProcessing;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IProcessing, AxiosError, {
        data: any
    }, unknown>({
        mutationFn: async ({data}) => {
            return await doMutation(data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ['useApiGetCatalogue']});
            if (selectedCategory) {
                await queryClient.invalidateQueries({queryKey: ['useApiGetCategory', selectedCategory.id]});
            }
            if (selectedEstimate) {
                await queryClient.invalidateQueries({queryKey: ['useApiGetEstimateUserfields', selectedEstimate.id]});
            }
        },
    });
};


export default useApiCreateProcessing;
